import { t } from "@lingui/macro";
import React from "react";

import { Box, Text } from "@whoosh/design-system/src/components/primitive";

export type SignupStatusOption =
  | "WAITLIST"
  | "CONFIRMED"
  | "REQUEST"
  | "CHECKED_IN"
  | "NONE";

type SignupStatusProps = {
  status: SignupStatusOption;
};

const Pill = ({ children }: { children: React.ReactNode }) => (
  <Box bg="surface-primary" py={1} px={2} borderRadius="1">
    {children}
  </Box>
);

export const SignupStatus = ({ status }: SignupStatusProps) => {
  switch (status) {
    case "WAITLIST":
      return (
        <Pill>
          <Text variant="mainTiny" color="text-accent-blue-primary">
            {t`Waitlist`}
          </Text>
        </Pill>
      );
    case "CONFIRMED":
    case "CHECKED_IN":
      return (
        <Pill>
          <Text variant="mainTiny" color="main-primary-700">
            {t`Confirmed`}
          </Text>
        </Pill>
      );
    default:
      return null;
  }
};
